import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import { getIn } from 'formik';
import FormCheckboxButtonLabel from './FormCheckboxButtonLabel';
import CheckboxInput from '../checkbox/CheckboxInput';
import formPropTypes from '../../prop-types/formPropTypes';

var FormCheckboxButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FormCheckboxButton, _Component);

  function FormCheckboxButton(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function (event) {
      var field = _this.props.field;

      _this.setState({
        focused: false
      });

      field.onBlur(event);
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;
      field.onChange(event);

      if (onChange) {
        onChange(event);
      }
    };

    _this.state = {
      focused: false
    };
    return _this;
  }

  var _proto = FormCheckboxButton.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        form = _this$props2.form,
        field = _this$props2.field,
        id = _this$props2.id,
        disabled = _this$props2.disabled,
        buttonType = _this$props2.buttonType,
        buttonSize = _this$props2.buttonSize,
        buttonSkin = _this$props2.buttonSkin,
        labelOnly = _this$props2.labelOnly,
        children = _this$props2.children;
    var focused = this.state.focused;
    var value = getIn(form.values, field.name);
    return /*#__PURE__*/React.createElement(FormCheckboxButtonLabel, {
      focused: focused,
      checked: value,
      disabledValue: disabled,
      buttonType: buttonType,
      buttonSize: buttonSize,
      buttonSkin: buttonSkin,
      labelOnly: labelOnly
    }, /*#__PURE__*/React.createElement(CheckboxInput, {
      id: id,
      name: field.name,
      type: "checkbox",
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      value: value,
      disabled: disabled
    }), children);
  };

  return FormCheckboxButton;
}(Component);

FormCheckboxButton.defaultProps = {
  buttonType: 'default',
  buttonSize: 'default',
  buttonSkin: 'primary',
  labelOnly: false,
  onChange: null,
  disabled: false,
  children: null
};
export default FormCheckboxButton;